import { render, staticRenderFns } from "./AutoOrder.vue?vue&type=template&id=42e28d31&scoped=true&"
import script from "./AutoOrder.vue?vue&type=script&lang=js&"
export * from "./AutoOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e28d31",
  null
  
)

export default component.exports